export const AUDIENCE_LEVELS = {
  NONE: 'NONE',
  LEGACY: 'LEGACY',
  PRO: 'PRO',
  ALL: 'ALL',
};

export const UPGRADE_REASONS = {
  FEATURE_UPGRADE: 'FEATURE_UPGRADE',
  AUDIENCE_UPGRADE: 'AUDIENCE_UPGRADE',
};

export const AUDIENCE_MODES = {
  FILTERING: 'FILTERING',
  TARGETING: 'TARGETING',
};

export const EVERYONE = 'Everyone';
